'use es6';

import { memo } from 'react';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const CalleeSkeleton = ({
  className
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: className,
    "data-selenium-test": "callee-skeleton",
    children: /*#__PURE__*/_jsx(SkeletonBox, {
      width: 120,
      height: 16
    })
  });
};
CalleeSkeleton.propTypes = {
  className: PropTypes.string
};
CalleeSkeleton.defaultProps = {
  className: 'p-bottom-2'
};
export default /*#__PURE__*/memo(CalleeSkeleton);